import { Box } from '@mui/material';
import { DataGridPro, DataGridProProps, GridColDef } from '@mui/x-data-grid-pro';
import React from 'react';

import { RouterLink } from 'app/components/router-link';
import { Mcc } from 'app/model/cris/mcc';
import { DataGridFormatters } from 'app/utils/data-grid-formatters';

interface MccListGridProps extends Omit<DataGridProProps<Mcc>, 'columns'> {
    rows: Mcc[];
}

export const MccListGrid: React.FunctionComponent<MccListGridProps> = (props) => (
    <Box sx={{ width: '100%', display: 'grid', height: '100%' }}>
        <DataGridPro {...props} columns={columns} />
    </Box>
);

const columns: Array<GridColDef<Mcc>> = [
    {
        field: 'id',
        headerName: 'ID',
        width: 150,
    },
    {
        field: 'name',
        headerName: 'Name',
        width: 250,
        renderCell: (data) => <RouterLink to={`/cris/mccs/${data.row.id}`}>{data.value}</RouterLink>,
    },
    {
        field: 'dateCreated',
        headerName: 'Date Created',
        width: 200,
        valueFormatter: DataGridFormatters.dateTimeFormatter,
    },
    {
        field: 'dateEdited',
        headerName: 'Date Edited',
        width: 200,
        valueFormatter: DataGridFormatters.dateTimeFormatter,
    },
];
